import _ from 'underscore';

// allow feature name for url filter
export const allowedUrlFilterFeatureName = [
  'AdGrid',
  'KeywordGrid',
  'AudienceAssociationGrid',
  'AudienceGrid',
  'ConversionGoalsGrid',
  'ProductGrid',
  'CampaignsGrid',
  'AdgroupGrid',
  'UETTagsGrid',
  'PerformanceGrid',
];
export const allowedUrlFilterKeys = ['filterExpressions', 'filterAlias', 'filterArguments'];

// usually sitemap and feature name map are 1:1
// sometimes one sitemap can map to multi url filter feature name
export const sitemapIdToFeatureName = {
  ads: ['AdGrid'],
  keywords: ['KeywordGrid'],
  audiences: ['AudienceAssociationGrid'],
  'audiences-library': ['AudienceGrid'],
  'conversion-goals': ['ConversionGoalsGrid'],
  products: ['ProductGrid'],
  campaigns: ['CampaignsGrid'],
  adgroups: ['AdgroupGrid'],
  'uet-tag': ['UETTagsGrid'],
  performance: ['PerformanceGrid'],
};

export const urlFilterType = _.reduce(allowedUrlFilterFeatureName, (memo, featureName) => _.extend(memo, { [featureName]: `UrlFilter_${featureName}` }), {});

export const featureNameToUrlFilter = urlFilterType;
